<template>
    <div style="overflow:hidden;">
        <div id="content" class="w usr_content">
            <div class="u_nav">
                <ul class="uv_ul">
                    <li><a href="javascript:;" @click="$router.push({path: '/user_order'})" class="uic uic1">我的订单</a></li>
                    <li><a href="javascript:;" class="uic uic2" @click="$router.push({path: '/weishouhuo', query:{status:'已发货',showVideo:1,}})">物流查询</a></li>
                    <li><a href="javascript:;" class="uic uic3" @click="$router.push({path: '/weipingjia', query:{status:'待评价',showVideo:1,}})">评论晒单</a></li>
                </ul>
                <p class="uline">&nbsp;</p>
                <ul class="uv_ul">
                    <!-- <li><a href="javascript:;" @click="$router.push({path: '/user_infor'})" class="uic uic4">会员首页</a></li> -->
                    <li><a href="javascript:;" @click="user" class="uic uic4">会员首页</a></li>
                    <li><a href="javascript:;" @click="$router.push({path: '/pay_password'})" class="uic uic8">支付密码</a></li>
                    <li><a href="javascript:;" @click="$router.push({path: '/user_coupon'})" class="uic uic5">优惠券</a></li>
                    <li><a href="javascript:;" @click="$router.push({path: '/user_fav'})" class="uic uic6">我的收藏</a></li>
                    <li><a href="javascript:;" @click="$router.push({path: '/user_address'})" class="uic uic7">收货地址</a></li>
                    <li><a href="javascript:;" @click="$router.push({path: '/user_grade'})" class="uic uic8">我的积分</a></li>
                </ul>
                <p class="uline">&nbsp;</p>
                <ul class="uv_ul">
                    <li><a href="javascript:;" @click="$router.push({path: '/user_profile'})" class="uic uic9">设置中心</a></li>
                    <li><a href="javascript:;" @click="$router.push({path: '/help'})" class="uic uic10">帮助中心</a></li>
                    <li><a href="javascript:;" @click="$router.push({path: '/user_faq'})" class="uic uic11">意见反馈</a></li>
                </ul>
            </div>
            <div>
                <router-view></router-view>
            </div>
        </div>
    </div>    
</template>
<script>
import Public_user_home from "@/components/user/Index"
import Public_user_order from "@/components/order/Index"
import Public_user_coupon from "@/components/coupon/Index"
import Public_user_fav from "@/components/fav/Index"
import Public_user_address from "@/components/address/Index"
import Public_user_grade from "@/components/grade/Index"
import Public_user_profile from "@/components/profile/Index"
import { setCookie,getCookie,delCookie } from '../../assets/js/cookie.js'
export default {
    components:{
        "public-home":Public_user_home,
        'public-order':Public_user_order,
        "public-coupon":Public_user_coupon,
        "public-fav":Public_user_fav,
        "public-address":Public_user_address,
        "public-grade":Public_user_grade,
        "public-profile":Public_user_profile
    },
    data() {
        return {
            activeName:'order',
            tabPosition: 'left',
            name: '',
        };
    },
    mounted(){
		/*页面挂载获取保存的localStorage值，渲染到页面上*/
        if(window.localStorage.getItem("user")){
            this.name = JSON.parse(window.localStorage.getItem("user")).username
        }
	},
    methods: {
        handleClick(tab, event) {
        },
        user(){
            if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_infor')
			}else{
				this.$router.push('/login')
			}
        },
    }
};
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/common/user-side.vue